import { ArrowRight } from "lucide-react";
import { PAYMENT_URL, DARK_TEXTURE } from "../lib/site";
import { Reveal, CtaButton } from "./Reveal";

export default function FinalCta() {
  return (
    <section id="enroll" data-testid="final-cta-container" className="grain relative overflow-hidden bg-gradient-to-b from-[#1C102D] to-[#100D18] py-24 sm:py-36">
      <img
        src={DARK_TEXTURE}
        alt=""
        aria-hidden="true"
        loading="lazy"
        className="pointer-events-none absolute inset-0 h-full w-full object-cover opacity-[0.08]"
      />
      <div className="drift pointer-events-none absolute left-1/2 top-1/2 h-96 w-[46rem] -translate-x-1/2 -translate-y-1/2 rounded-full bg-[#7C3AED]/20 blur-[140px]" />

      <div className="relative mx-auto max-w-3xl px-5 text-center sm:px-8">
        <Reveal>
          <span className="font-mono text-[11px] font-bold uppercase tracking-[0.3em] text-[#9B5CF0]">
            Limited Live Batch • 25–26 October 2026
          </span>
        </Reveal>
        <Reveal delay={0.1}>
          <h2 data-testid="final-cta-headline" className="mt-6 text-4xl font-extrabold leading-[1.1] tracking-tight text-white sm:text-5xl lg:text-6xl">
            Your Next Chapter Starts With{" "}
            <span className="bg-gradient-to-r from-[#C9B8F5] to-[#9B5CF0] bg-clip-text text-transparent">One Step.</span>
          </h2>
        </Reveal>
        <Reveal delay={0.2}>
          <p className="mx-auto mt-6 max-w-xl text-base leading-relaxed text-[#B8B1C8] sm:text-lg">
            Learn to create digital products using AI and discover how to start building your own online business.
          </p>
        </Reveal>
        <Reveal delay={0.3}>
          <div className="mt-8 flex items-center justify-center gap-3 text-sm font-semibold">
            <span className="text-[#777181] line-through">₹999</span>
            <span className="text-2xl font-extrabold text-white">₹199</span>
            <span className="rounded-full bg-[#7C3AED]/25 px-3 py-1 font-mono text-[11px] font-bold uppercase tracking-widest text-[#C9B8F5]">
              80% OFF
            </span>
          </div>
        </Reveal>
        <Reveal delay={0.4}>
          <div className="mt-9">
            <CtaButton href={PAYMENT_URL} testId="final-cta-btn" dark className="px-10 py-4 text-base">
              Join the 2-Day Bootcamp — ₹199 <ArrowRight size={18} strokeWidth={2.5} />
            </CtaButton>
          </div>
          <p className="mt-6 text-xs font-medium tracking-wide text-[#B8B1C8]">
            One-Time Registration • 2 Live Sessions • Practical Training
          </p>
        </Reveal>
      </div>
    </section>
  );
}
